<h1>User Details</h1>
<div class="ui-g ui-fluid">
  <div class="ui-g-12 ui-lg-12">
    <div class="card card-w-title">
      <br />
      <form [formGroup]="userForm" (ngSubmit)="save(userForm.value)" autocomplete="off">
        <div class="ui-grid-row">
          <div class="ui-g-12">
            <div class="ui-grid-col-2 ui-sm-12"><label for="name">First Name</label></div>
            <div class="ui-grid-col-10 ui-sm-12">
              <input
                pInputText
                id="firstName"
                formControlName="firstName"
                tabindex="3"
                maxlength="100"
              />
            </div>
          </div>
        </div>

        <div class="ui-grid-row">
          <div class="ui-g-12">
            <div class="ui-grid-col-2 ui-sm-12"><label for="town">Last Name</label></div>
            <div class="ui-grid-col-10 ui-sm-12">
              <input
                pInputText
                id="lastName"
                formControlName="lastName"
                tabindex="4"
                maxlength="100"
              />
            </div>
          </div>
        </div>

        <div class="ui-grid-row">
          <div class="ui-g-12">
            <div class="ui-grid-col-2 ui-sm-12"><label for="email">Email Address</label></div>
            <div class="ui-grid-col-10 ui-sm-12">
              <input pInputText id="email" formControlName="email" tabindex="1" maxlength="254" />
            </div>
          </div>
        </div>

        <div class="ui-grid-row">
          <div class="ui-g-12">
            <div class="ui-grid-col-2 ui-sm-12">
              <label for="phoneNumber">Telephone Number</label>
            </div>
            <div class="ui-grid-col-10 ui-sm-12">
              <input
                pInputText
                type="tel"
                id="phoneNumber"
                formControlName="phoneNumber"
                tabindex="2"
                maxlength="20"
              />
            </div>
          </div>
        </div>

        <div class="ui-grid-row">
          <button
            type="submit"
            icon="fa ui-icon-check"
            class="green-btn btn-to-right"
            pButton
            label="Save"
            [disabled]="userForm.invalid"
            tabindex="23"
          ></button>
        </div>

        <ng-template #loading>Loading...</ng-template>
      </form>
    </div>
  </div>
</div>
